import { keyBy } from "lodash";
import * as actionTypes from "./actionTypes";

export function fetchPageTypes(payload) {
  return { type: actionTypes.FETCH_PAGE_TYPES, payload };
}
export function fetchPageTypesSuccess(pagetypes) {
  const byId = keyBy(pagetypes, (type) => type.pagetypeUid);
  return { type: actionTypes.FETCH_PAGE_TYPES_SUCCESS, payload: { byId } };
}
